import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { getDotColor } from './utils/getDotColor';
export default function DayIndicator({ day, testId }) {
    if (day.isInThePast)
        return null;
    return (_jsx("div", { className: classNames('inline-block h-[5px] w-[5px] rounded-full', getDotColor(day)), "data-testid": testId.append(day.alert ? 'alert' : 'available') }));
}
